"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["size", "width", "height", "fill"];

var _default = function _default(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? size : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? size : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#808080' : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: size,
    height: size,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, restProps), /*#__PURE__*/_react["default"].createElement("g", {
    id: "*image"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    id: "Vector (Stroke)",
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M3.33301 2.66634C2.96482 2.66634 2.66634 2.96482 2.66634 3.33301V12.6663C2.66634 13.0345 2.96482 13.333 3.33301 13.333H12.6663C13.0345 13.333 13.333 13.0345 13.333 12.6663V3.33301C13.333 2.96482 13.0345 2.66634 12.6663 2.66634H3.33301ZM1.33301 3.33301C1.33301 2.22844 2.22844 1.33301 3.33301 1.33301H12.6663C13.7709 1.33301 14.6663 2.22844 14.6663 3.33301V12.6663C14.6663 13.7709 13.7709 14.6663 12.6663 14.6663H3.33301C2.22844 14.6663 1.33301 13.7709 1.33301 12.6663V3.33301Z",
    fill: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    id: "Vector (Stroke)_2",
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M5.66667 5.33333C5.48257 5.33333 5.33333 5.48257 5.33333 5.66667C5.33333 5.85076 5.48257 6 5.66667 6C5.85076 6 6 5.85076 6 5.66667C6 5.48257 5.85076 5.33333 5.66667 5.33333ZM4 5.66667C4 4.74619 4.74619 4 5.66667 4C6.58714 4 7.33333 4.74619 7.33333 5.66667C7.33333 6.58714 6.58714 7.33333 5.66667 7.33333C4.74619 7.33333 4 6.58714 4 5.66667Z",
    fill: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    id: "Vector (Stroke)_3",
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M10.1956 6.19526C10.4559 5.93491 10.878 5.93491 11.1384 6.19526L14.4717 9.5286C14.7321 9.78894 14.7321 10.2111 14.4717 10.4714C14.2114 10.7318 13.7893 10.7318 13.5289 10.4714L10.667 7.60948L3.80506 14.4714C3.54471 14.7318 3.1226 14.7318 2.86225 14.4714C2.6019 14.2111 2.6019 13.7889 2.86225 13.5286L10.1956 6.19526Z",
    fill: fill
  })));
};

exports["default"] = _default;